<template>
  <div class="w-95 mx-auto mt-8 white pa-8">
    <h3 class="font-weight-bold">حضور در بازارهای جهانی</h3>
    <v-row class="justify-start mx-auto">
      <v-col cols="6" lg="1" xl="1" md="2" sm="6" v-for="(country,index) in countries.banners" :key="index" class="mt-10">
        <a :href="country.link_url" target="_blank">
          <div class="d-flex justify-center align-center flex-column">
            <v-img width="80" height="40" :src="country.file"></v-img>
            <p class="mt-3 text-center font-weight-bold pointer">{{country.title}}</p>
          </div>
        </a>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "CountriesCart",
  props:{
  countries:Array
  }
}
</script>

<style scoped>
.about-box {
  width: 80%;
  margin: 100px auto;
  padding: 50px 20px 100px 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  background-color: white;
  -webkit-clip-path: polygon(0 10%, 100% 0%, 100% 90%, 0% 100%);
  clip-path: polygon(0 10%, 100% 0%, 100% 90%, 0% 100%);
}
</style>